import { useState } from "react"

interface AreYouSureRequest {
    title: string
    subTitle?: string
    acceptText?: string
    processingText?: string
    action: () => Promise<any>
}

const useAreYouSureModal = () => {
    const [request, setRequest] = useState<AreYouSureRequest | null>(null)
    const [isProcessing, setIsProcessing] = useState<boolean>(false)

    const open = (next: AreYouSureRequest) => setRequest(next)

    const close = () => setRequest(null)

    const confirm = async () => {
        if (!request) return

        setIsProcessing(true)
        const result = await request.action()
        setIsProcessing(false)

        if (result) close()
        return result
    }

    const modalProps = {
        isOpen: !!request,
        modalTitle: request?.title ?? '',
        subTitle: request?.subTitle,
        onModalClose: close,
        handleAreYouSureAccept: confirm,
        handleAreYouSureDecline: async () => close(),
        areYouSureacceptText: isProcessing
            ? (request?.processingText ?? 'Working...')
            : (request?.acceptText ?? 'Confirm'),
        areYouSuredeclineText: 'Cancel'
    }

    return { open, close, isProcessing, modalProps }
}

export default useAreYouSureModal
